import { LinkButton } from '@carvana/helios-navigation';
import cx from 'classnames';
import { useModal } from '@carvana/helios-layout';
import RatingStars from '@carvana/stc-rating-stars';

import useAnalyticEvent from '../../shared/hooks/useAnalyticEvent';
import type { Review as ReviewType } from '../../api/strapi';
import {
  BottomContent,
  Container,
  StarsContainer,
  ReviewText,
  CustomerDetails,
  CustomerName,
  Date
} from './Review.styles';

type ReviewCardProps = {
  expanded?: boolean;
  openModal?: () => void;
  review: ReviewType;
};

const ReviewCard = ({ expanded, openModal, review }: ReviewCardProps) => {
  const { recordActionClicked } = useAnalyticEvent();

  const handleReadMore = () => {
    recordActionClicked('Landing Page', 'Read full review');
    if (openModal) {
      openModal();
    }
  };

  return (
    <Container className={cx({ expanded })}>
      <StarsContainer>
        <RatingStars rating={review.rating} />
      </StarsContainer>
      <ReviewText className={cx({ expanded })}>{expanded ? review.wholeReview : review.blurb}</ReviewText>
      {!expanded && <LinkButton onClick={handleReadMore}>Read More</LinkButton>}
      <BottomContent>
        <CustomerDetails>
          <CustomerName>{review.name}</CustomerName>
          &nbsp;
          <ReviewText>{`from ${review.state}`}</ReviewText>
        </CustomerDetails>
        <Date>{review.date}</Date>
      </BottomContent>
    </Container>
  );
};

type ReviewProps = {
  review: ReviewType;
};

const Review = ({ review }: ReviewProps) => {
  const { Modal, openModal } = useModal();
  const firstName = review.name.split(' ')[0];
  return (
    <>
      <ReviewCard review={review} openModal={openModal} />
      <Modal divLine modalHeader={`${firstName}’s Review`}>
        <ReviewCard review={review} expanded />
      </Modal>
    </>
  );
};

export default Review;
